export const templateTypes = [
  {
    key: "EXCEL",
    label: "Excel",
    tooltip: "Outputs an Excel spreadsheet (.xlsx).",
  },
  {
    key: "WORD",
    label: "Word — Legacy (Word)",
    tooltip:
      "Outputs a Word document (.docx). Legacy approach — prefer Word Dynamic for new templates.",
  },
  {
    key: "WORD_JINJA",
    label: "Word — Dynamic (Word Jinja)",
    tooltip:
      "Outputs a Word document (.docx). Supports Jinja2 templating ({{ variable }}, conditionals, loops).",
  },
  {
    key: "WORD_JINJA_ENDORSEMENT",
    label: "Word — Single Endorsement (Word Jinja Endorsement)",
    tooltip:
      "Outputs a Word document (.docx) for a single endorsement. The template title must match the endorsement name exactly. Used in the Endorsements tab.",
  },
  {
    key: "ENDORSEABLE_WORD_JINJA",
    label: "Word — Policy with Endorsements (Endorseable Word Jinja)",
    tooltip:
      "Always outputs a PDF. Merges the policy document with selected endorsements into a single PDF.",
  },
  {
    key: "PDF_ENDORSEMENT",
    label: "PDF — Single Endorsement",
    tooltip:
      "A static PDF used as a single endorsement. No templating. The first word of the filename is used as the endorsement name.",
  },
  {
    key: "ENDORSABLE_PDF",
    label: "PDF — Policy with Endorsements",
    tooltip:
      "A static PDF policy document. Always outputs a PDF merged with all matched endorsements.",
  },
];

export const templateExtension = (type) => {
  switch (type) {
    case "EXCEL":
      return ".xlsx";
    case "ENDORSEABLE_WORD_JINJA":
      return ".pdf";
    case "WORD":
    case "WORD_JINJA":
    case "WORD_JINJA_ENDORSEMENT":
      return ".docx";
    case "PDF_ENDORSEMENT":
    case "ENDORSABLE_PDF":
      return ".pdf";
    default:
      return ".bin";
  }
};

export const replaceExtension = (filename, newExt) => {
  if (!filename) return filename;
  return filename.replace(/\.[^.]+$/, "") + newExt;
};
